import {useAppContent} from "../templates/playMarket/logic/useAppContent.tsx";
import {IGPlayInfo} from "@pwlaunch/shared//interfaces/IWebAppWorkerRecord.ts";
import get from "lodash/get";
import {AllPaths} from "@pwlaunch/shared//lib/ugly";
import {TWebAppTemplateData} from "@pwlaunch/shared//_data/webAppsDesignConfig/config.ts";

export const useLegacyAppContent = (): IGPlayInfo<'playMarket'> =>  {
    const appConfig = useAppContent<'playMarket'>();

    type TConfig = typeof appConfig;

    type OriginalKeys = Exclude<
        keyof TConfig,
        'dataMap' | 'templateKey' | 'updatedDate'
    >

    const mappedFields: {
        [TKey in OriginalKeys]: AllPaths<TWebAppTemplateData<'playMarket'>>
    } = {
        name: 'locale.name',
        description: 'locale.description',
        owner: 'locale.owner',
        appSecurity: 'additionalData.security',
        downloadsCount: 'locale.rating.downloadsCount',
        reviews: 'locale.reviews',
        icon: 'locale.icon',
        hideHeader: 'additionalData.tweaks.hideHeader',
        rating: 'locale.rating.rating',
        isVerify: 'locale.isVerify',
        installButton: 'additionalData.installButtonBehavior',
        tags: 'locale.tags',
        screens: 'locale.screens',
        ratingCharts: 'locale.rating.ratingValues',
        ratingsCount: 'locale.rating.ratingsCount',
        //updatedDate: 'locale.updatedDate',
        whatsNewContent: 'locale.whatsNew.content',
        enabledTrailer: 'locale.trailer.enabled',
        trailerUrl: 'locale.trailer.url',
    }

    return (
        new Proxy<IGPlayInfo<'playMarket'>>(
            appConfig as IGPlayInfo<'playMarket'>,
            {
                get(_, name: keyof IGPlayInfo<'playMarket'>) {
                    if (name === 'dataMap') return appConfig.dataMap;
                    let value: any;
                    if (name in mappedFields) {
                        value = get(appConfig.dataMap, mappedFields[name as keyof typeof mappedFields]);
                        if (typeof value === 'undefined') {
                            value = get(appConfig, name)
                        }
                    } else {
                        value = get(appConfig, name)
                    }
                    return value;
                },
            }
        )
    )
}
